var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _setup.checkElementTruncation,
          expression: "checkElementTruncation",
        },
      ],
      staticClass: "note",
      on: {
        click: function ($event) {
          return _setup.editNote(_vm.note)
        },
      },
    },
    [
      _c("span", { class: [_setup.icons.note, "note-icon", "lf-icon__md"] }),
      _c(
        "div",
        { staticClass: "info-container" },
        [
          _setup.isTruncated
            ? _c(_setup.LexonTooltipComponent, {
                attrs: {
                  message: _vm.note.note.title,
                  disabled: false,
                  position: "top",
                  isWidthAuto: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator-element",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { ref: "elementRef", staticClass: "note-name" },
                            [_vm._v(_vm._s(_vm.note.note.title))]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3228825869
                ),
              })
            : _c("span", { ref: "elementRef", staticClass: "note-name" }, [
                _vm._v(_vm._s(_vm.note.note.title)),
              ]),
          _c("p", { staticClass: "note-subject" }, [
            _vm._v(_vm._s(_vm.note.note.subject)),
          ]),
        ],
        1
      ),
      _c("span", {
        class: [_setup.icons.remove, "remove-icon", "lf-icon__sm"],
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return (() => _setup.showRemoveDialog(_vm.note)).apply(
              null,
              arguments
            )
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }